<template>
  <a-tooltip placement="top" :title="item.name">

    <div class="cont-row" style="width: 100%">  
      <div class="cont-row-box">
        <div class="table-cell">
          <span>{{ item.name  }} 
          </span>
          <span v-if="item.fieldUnit && item.fieldUnit.symbol">
          ({{ item.fieldUnit.symbol }})
          </span>
        </div>
        <div class="container-sort" @click="$emit('handleSort', item, index)">
          <div class="sort-cont" :style="tableRowHeight()">
            <span class="sort-up" :class="item.sortable === 'asc' ? 'active' : ''"
              ><a-icon type="caret-up"
            /></span>
            <span class="sort-down" :class="item.sortable === 'desc' ? 'active' : ''"
              ><a-icon type="caret-down"
            /></span>
          </div>
        </div>
        <a-dropdown v-model="flag" :trigger="['click']" v-if="item.dataType === 'ENUM'" :getPopupContainer="trigger => trigger.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode">
          <icon-font type="icon-Filter1" class="table-filter" :style="enumValues&&enumValues.length>0?'color:#22AC35':''"  @click="e => e.preventDefault()" />
          <a-menu slot="overlay">
            <a-input-search placeholder="输入名称搜索" @search="onSearch" />
            <a-menu-divider />
            <a-checkbox-group v-model="enumValues" class="widget-table-checkbox">
              <a-checkbox :value="v" v-for="v in enumList" :key="v">{{ v }}</a-checkbox>
            </a-checkbox-group>
            <a-menu-divider />
            <a-button type="link" @click="confirm" class="head-drop-btn">确定</a-button>
            <a-button type="link"  @click="flag = false" class="head-drop-btn">取消</a-button>
          </a-menu>
        </a-dropdown>

        <a-dropdown v-model="flag" :trigger="['click']" v-if="item.dataType === 'STRING'" :getPopupContainer="trigger => trigger.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode">
          <icon-font type="icon-Filter1" class="table-filter" :style="searchValue&&searchValue.length>0?'color:#22AC35':''"  @click="e => e.preventDefault()"/>
          <a-menu slot="overlay">
            <a-input-search v-model="searchValue" placeholder="输入名称搜索" @search="confirmSearch"/>
          </a-menu>
        </a-dropdown>
      </div>           
    </div>
  </a-tooltip>
</template>
<script>
import { getEnumDataNew } from "@/api/template";

export default {
  props: {
    item: Object,
    filterConditions: Array,
    index: Number,
    tableRowHeight: Function
  },
  data() {
    return {
      flag: false,
      enumList: [],
      enumAllList: [],
      enumValues: [],
      searchValue: '',
    }
  },
  inject: ["getDashboardDynamicData", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
  },
  methods: {
    // 获取枚举列表
    getEnumData(tableId, field, contextData) {
      if(tableId > 0){
        let data = this.$deepclone(contextData)
        if(!data.datasource) {
          data.datasource = this.dashbordData.datasource
          data.accountIds = this.dashbordData.accountIds
          data.tableId = this.dashbordData.tableId
          data.filterType = this.dashbordData.filterType
        }
        getEnumDataNew(tableId, field, data).then((res) => {
          this.enumList = res.data;
          this.enumAllList = res.data;
        });
      }
    },
    confirm() {
      this.$emit('filterConfirm', {
        id: this.item.id,
        name: this.item.field,
        dataType: this.item.dataType,
        relation: "AND",
        op: "in",
        value: this.enumValues
      }, !!this.enumValues.length)
    },
    confirmSearch(value){
      this.$emit('filterConfirm', {
        id: this.item.id,
        name: this.item.field,
        dataType: this.item.dataType,
        relation: "AND",
        op: "like",
        value: value.trim()
      }, !!value)
    },
    onSearch(value) {
      if(value) {
        this.enumList = this.enumAllList.filter(v => v.indexOf(value.trim()) > -1 || v.toLowerCase().indexOf(value.trim().toLowerCase()) > -1)
      } else {
        this.enumList = this.enumAllList
      }
    },
    setTableFilter(arr) {
      let obj = arr.find(v => v.id === this.item.id)
      if(obj) {
        this.enumValues = obj.value
      }
    }
  },
  mounted() {
    if(this.item.dataType === 'ENUM') {
      this.getEnumData(this.$parent.tableId, this.item.field, this.$parent.optionsData.dynamicData.contextData)
      let obj = this.filterConditions.find(v => v.id === this.item.id)
      if(obj) {
        this.enumValues = obj.value
      }
    }else if(this.item.dataType === 'STRING'){
      let obj = this.filterConditions.find(v => v.id === this.item.id)
      if(obj) {
        this.searchValue = obj.value
      }
    }
  }
}
</script>
<style scoped lang="less">
.head-drop-btn {
  color: #22ac35;
  padding: 0 8px;
}
.table-filter {
  cursor: pointer;
  display: inline-block;
  width: 28px;
  height: 100%;
  line-height: 30px;
  /deep/ svg {
    vertical-align: middle;
  }
  &:hover {
    background: #E5E5E5;
  };
}
.cont-row{
  display: flex;
  align-items: center;
  overflow: hidden;
  .container-sort{
    width: 12px;
    height: 100%;
    margin-left: 8px;
  }
  .cont-row-box {
    flex: none;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    & > * {
      vertical-align: middle;
      display: inline-block;
    }
  }
  .sort-cont {
    width:12px;
    position: relative;
    cursor: pointer;
    .sort-down,
    .sort-up {
      color: #9CA9CB;
      font-size: 12px;
      position: absolute;
      width: 12px;
      height: 12px;
    }
    .sort-down.active,
    .sort-up.active {
      color: #22ac35;
    }
    .sort-up {
      top: -4px;
      left: 0;
    }
    .sort-down {
      top: 4px;
      left: 0;
    }
  }
}
</style>
<style lang="less">
.widget-table-checkbox {
  width: 100%;
  max-height: 500px;
  overflow: auto;
  .ant-checkbox-wrapper {
    display: block;
    &:first-child {
      margin-left: 8px;
    }
  }
}

</style>